import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { URLS } from '../constants/URLS';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class UserchannelService {

  formhttpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  constructor(
    private http: HttpClient,
    private apiService: ApiService
    ) { }


  getChannelByUserId(channelId) {
    return this.apiService.post(`${URLS.getSectionsContent}?start_index=${0}&last_index=${20}&channel_id=${channelId}`,{}).pipe(
      map(responseData => {
        if (responseData.status == 0) {
          return responseData.data;
        } else {
          return undefined;
        }
      }), catchError(errorRes => {
        return throwError(errorRes);
      }))
  }

  getCcPrimeChannelByUserId(channelId, firstIndex, lastIndex) {  
    return this.apiService.get(`${URLS.getCCPrimeChannelVideos}?start_index=${firstIndex}&last_index=${lastIndex}&channel_id=${channelId}`, this.formhttpOptions).pipe(
      map(responseData => {
        if (responseData.status == 0) {
          return responseData;
        } else {
          return undefined;
        }
      }), catchError(errorRes => {
        return throwError(errorRes);
      }))
  }

  getchannelInfoByChannelId() {
    return this.apiService.get(URLS.getSectionsContent, this.formhttpOptions).pipe(
      map(responseData => {
        if (responseData.status == 0) {
          return responseData.data;
        } else {
          return undefined;
        }
      }), catchError(errorRes => {
        return throwError(errorRes);
      })
    ).toPromise();
  }

  getPrimeChannels(){
    return this.apiService.get(URLS.getPrimeChannel).pipe(
      map(responseData => {
        if(responseData.status === 'success'){
          return responseData.data;
        }else{
          return undefined
        }
      }),catchError(errorRes => {
        return throwError(errorRes);
      })
    )
  }
}